module.exports = __webpack_public_path__ + "img/word.7a2d12d7.svg";